import { Button, Flex, Typography } from "antd";
import {
  CheckOutlined,
  UndoOutlined,
  DeleteOutlined,
  CloseOutlined,
  EditOutlined,
} from "@ant-design/icons";
import useDelete from "hooks/useDelete";
import useCreate from "hooks/useCreate";
import { useCalendarIssues } from "components/CalendarIssues/context";

const TaskTitle = ({ close, onEdit, tasks }) => {
  const { refetchTasks } = useCalendarIssues();
  const task = tasks[0];
  const { _delete } = useDelete({
    path: `/tasks/${task.id}`,
    onSuccess: () => {
      refetchTasks();
      close();
    },
  });

  const { create: toggleComplete } = useCreate({
    path: `/tasks/${task.id}/toggle_completed`,
    success_message: "Zaktualizowano pomyślnie.",
    onSuccess: () => {
      refetchTasks();
      close();
    },
  });

  return (
    <div className="calendar-viewer">
      <div className="calendar-viewer__header">
        <Button onClick={close} type="primary" ghost icon={<CloseOutlined />} />
      </div>
      <Typography.Text strong delete={task.is_completed}>
        {task.content}
      </Typography.Text>
      <Flex justify="flex-end" gap={10} style={{ marginTop: 10 }}>
        <Button
          onClick={_delete}
          danger
          type="primary"
          ghost
          icon={<DeleteOutlined />}
        />
        <Button
          onClick={() => toggleComplete({})}
          type="primary"
          ghost
          icon={task.is_completed ? <UndoOutlined /> : <CheckOutlined />}
        />
        <Button
          onClick={() => onEdit(task)}
          type="primary"
          ghost
          icon={<EditOutlined />}
        />
      </Flex>
    </div>
  );
};

export default TaskTitle;
